import React, {useEffect, useMemo} from "react";
import { useFormik } from "formik";
import { yupSchemaStep4 } from "schemas/yupSchema";
import NavigateButtons from "components/NavigateButtons";
import { goToTop } from "helpers/helpers";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import {prepareDataStep4, prepareDataStep4PIF, prepareDataStep6} from "helpers/PrepareData";
import { toast } from "react-toastify";
import listaFurnizoriActivi from "data/listaFurnizoriActivi";
import TextInfo from "components/TextInfo";
import AttachFileStep4 from "components/AttachFileStep4";
import CustomSelect from "components/CustomSelect";

export default function Step4({
   currentStep,
   setCurrentStep,
   stepsState,
   persistState,
   setLoading,
   setRedirectFinalStep,
   firstSubmit,
   setFirstSubmit,
}) {
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: stepsState.step4,
      validationSchema: yupSchemaStep4,
      validateOnChange: firstSubmit,
      validateOnBlur: false,
      onSubmit: values => {
         goToTop();
         saveData(values);
      },
   });

   const saveData = async values => {
      setLoading(true);
      var goToNextStep = false;
      // daca nu beneficiezi de gaze naturale la adresa locului de consum => mergi direct la pasul 10 (NU_BENEFICIEZI_GAZE)
      if (values.beneficieziInPrezent === false) {
         if (values.esteBransat === '') {
            formik.setFieldError("esteBransat", "Trebuie să selectezi o opțiune.");
         } else if (values.esteBransat === false) {
            redirectToCerereRacordare();
         } else if (values.esteBransat === true) { // acesta este flux de PIF
            values.isPIF = true;
            // postStep4PIF(values);
            goToNextStep = true;
         }

      } else {
         if(values.premierEnergyTitular === false) {
            // requestFurnizorChange(values);
            document.getElementById('actionButton').style.display = "none";
            const allData = { opportunityId: stepsState.opportunityId, furnizorActual: values.furnizorActual };
            const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS4_FURNIZORI, RequestMethod.POST, { data: allData });

            if (response.isSuccess === true && response.response == 'success') {
               goToNextStep = true;
            } else {
               document.getElementById('actionButton').style.display = "block";
               toast.error("A apărut o eroare. Vă rugăm să încercați din nou.");
            }
         } else {
            values.isPIF = false;
            goToNextStep = true;
            // redirectStep5(values);
         }
      }
      if(goToNextStep === true) {
         persistState(prevState => {
            return {
               ...prevState,
               step4: {
                  ...prevState.step4,
                  beneficieziInPrezent: values.beneficieziInPrezent,
                  schimbiTitular: values.schimbiTitular,
                  premierEnergyTitular: values.premierEnergyTitular,
                  furnizorActual: values.furnizorActual,
                  esteBransat: values.esteBransat,
                  isPIF: values.isPIF,
               },
            };
         });
         window.dataLayer.push({ event: "pas_4_casnici", info: { pagina: "step-4", finalizat: "da" } });
         setCurrentStep(currentStep + 1);
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
         setFirstSubmit(false);
      }
      setLoading(false);
   }

   // const postStep4PIF = async values => {
   //    const allData = { ...values, opportunityId: stepsState.opportunityId };
   //    // console.log('allData', await prepareDataStep4PIF(allData));
   //    const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS4, RequestMethod.POST, { data: await prepareDataStep4PIF(allData) });
   //    if (response.isSuccess) {
   //       persistState(prevState => {
   //          return {
   //             ...prevState,
   //             step4: {
   //                ...prevState.step4,
   //                beneficieziInPrezent: values.beneficieziInPrezent,
   //                schimbiTitular: values.schimbiTitular,
   //                premierEnergyTitular: values.premierEnergyTitular,
   //                furnizorActual: values.furnizorActual,
   //                esteBransat: values.esteBransat,
   //                isPIF: values.isPIF,
   //             },
   //          };
   //       });
   //       window.dataLayer.push({ event: "pas_4_casnici", info: { pagina: "step-4", finalizat: "da" } });
   //       setCurrentStep(currentStep + 1);
   //       localStorage.setItem("sessionCurrentStep", currentStep + 1);
   //       setFirstSubmit(false);
   //    } else {
   //       toast.error("A apărut o eroare. Vă rugăm să încercați din nou.");
   //    }
   // };
   // const requestFurnizorChange = async values => {
   //    document.getElementById('actionButton').style.display = "none";
   //    const allData = { opportunityId: stepsState.opportunityId, furnizorActual: values.furnizorActual };
   //    const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS4_FURNIZORI, RequestMethod.POST, { data: allData });
   //
   //    if (response.isSuccess === true && response.response == 'success') {
   //       redirectStep5(values);
   //    } else {
   //       document.getElementById('actionButton').style.display = "block";
   //       toast.error("A apărut o eroare. Vă rugăm să încercați din nou.");
   //    }
   // };

   // const redirectStep5 = async values => {
   //    // console.log('value231s', values);
   //    values.isPIF = false; // Flux clasic, se continua contractarea
   //    persistState(prevState => {
   //       return {
   //          ...prevState,
   //          step4: {
   //             ...prevState.step4,
   //             beneficieziInPrezent: values.beneficieziInPrezent,
   //             schimbiTitular: values.schimbiTitular,
   //             premierEnergyTitular: values.premierEnergyTitular,
   //             furnizorActual: values.furnizorActual,
   //             esteBransat: values.esteBransat,
   //             isPIF: values.isPIF,
   //          },
   //       };
   //    });
   //    window.dataLayer.push({ event: "pas_4_casnici", info: { pagina: "step-4", finalizat: "da" } });
   //    setCurrentStep(currentStep + 1);
   //    localStorage.setItem("sessionCurrentStep", currentStep + 1);
   //    setFirstSubmit(false);
   // };

   const redirectToCerereRacordare = () => {
      localStorage.clear();
      window.location.href = "https://www1.premierenergy.ro/siteCerereRacordare2.html";
   }

   const showListaFurnizori = async values => {
      document.getElementById('listaFurnizori').style.display="block";
   };
   const hideListaFurnizori = () => {
      document.getElementById('listaFurnizori').style.display="none";
   };

   const furnizoriActuali = useMemo(() => {
      return listaFurnizoriActivi.map(item => {
         return { value: item.cui, label: item.furnizor };
      }).sort((a, b) => a.label.localeCompare(b.label));  // Sorts based on the 'label' property
   });

   const formSubmition = e => {
      e.preventDefault();
      setFirstSubmit(true);
      formik.handleSubmit();
   };

   useEffect(() => {
      // formik.setFieldValue("esteBransat", '')
      // formik.setFieldValue("schimbiTitular", true)
      // formik.setFieldValue("esteBransat", false)
      // formik.setFieldValue("premierEnergyTitular", true)

   }, []);

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-4">
                     <div className="row row-input mt-50">
                        <form onSubmit={e => formSubmition(e)}>
                           <div className="col-md-12">
                              <label>Beneficiezi în prezent de gaze naturale la adresa locului tău consum?</label>
                              <div className="row row-radio">
                                 <div className="col-6 pe-0">
                                    <input
                                       defaultChecked={formik.values.beneficieziInPrezent}
                                       onChange={() => {
                                          formik.setFieldValue("beneficieziInPrezent", true)
                                          formik.setFieldValue("isPIF", false)
                                          formik.setFieldValue("esteBransat", '')
                                       }
                                    }
                                       type="radio"
                                       id="beneficieziInPrezent"
                                       className="hidden"
                                       name="loc_consum"
                                    />
                                    <label className="label-radio radius-right-0" htmlFor="beneficieziInPrezent">
                                       DA
                                    </label>
                                 </div>

                                 <div className="col-6 ps-0">
                                    <input
                                       defaultChecked={formik.values.beneficieziInPrezent === false ? !formik.values.beneficieziInPrezent : null}
                                       onChange={() => {
                                          formik.setFieldValue("beneficieziInPrezent", false)
                                          formik.setFieldValue("esteBransat", '')

                                       }
                                    }
                                       type="radio"
                                       id="beneficieziInPrezent_nu"
                                       className="hidden"
                                       name="loc_consum"
                                    />
                                    <label className="label-radio radius-left-0" htmlFor="beneficieziInPrezent_nu">
                                       NU
                                    </label>
                                 </div>
                                 {formik.errors.beneficieziInPrezent && formik.touched.beneficieziInPrezent ? (
                                    <div className="text-center error-msg">{formik.errors.beneficieziInPrezent}</div>
                                 ) : null}
                              </div>
                           </div>

                           {formik.values.beneficieziInPrezent === true && ( // DA -> se continua pe fluxul existent, afisand celelalte 2 intrebari
                                 <>
                                    <div className="col-md-12 mt-50">
                                 <label>Vrei să schimbi titularul contractului de furnizare?</label>
                                 <div className="row row-radio">
                                    <div className="col-6 pe-0">
                                       <input
                                          defaultChecked={formik.values.schimbiTitular}
                                          onChange={() => formik.setFieldValue("schimbiTitular", true)}
                                          type="radio"
                                          id="schimbiTitular"
                                          className="hidden"
                                          name="titular"
                                       />
                                       <label className="label-radio radius-right-0" htmlFor="schimbiTitular">
                                          DA
                                       </label>
                                    </div>
                                    <div className="col-6 ps-0">
                                       <input
                                          defaultChecked={formik.values.schimbiTitular === false ? !formik.values.schimbiTitular : null}
                                          onChange={() => formik.setFieldValue("schimbiTitular", false)}
                                          type="radio"
                                          id="schimbiTitular_nu"
                                          className="hidden"
                                          name="titular"
                                          // value={true}
                                       />
                                       <label className="label-radio radius-left-0" htmlFor="schimbiTitular_nu">
                                          NU
                                       </label>
                                    </div>
                                    {formik.errors.schimbiTitular && formik.touched.schimbiTitular ? (
                                       <div className="text-center error-msg">{formik.errors.schimbiTitular}</div>
                                    ) : null}
                                 </div>
                              </div>

                              <div className="col-md-12 mt-50">
                                 <label>Premier Energy este actualul tau furnizor de gaze naturale?</label>
                                 <div className="row row-radio">
                                    <div className="col-6 pe-0">
                                       <input
                                          defaultChecked={formik.values.premierEnergyTitular}
                                          onChange={() => { formik.setFieldValue("premierEnergyTitular", true);}}
                                          type="radio"
                                          id="premierEnergyTitular"
                                          className="hidden"
                                          name="furnizor"
                                       />
                                       <label className="label-radio radius-right-0" htmlFor="premierEnergyTitular">
                                          DA
                                       </label>
                                    </div>
                                    <div className="col-6 ps-0">
                                       <input
                                          defaultChecked={formik.values.premierEnergyTitular === false ? !formik.values.premierEnergyTitular : null}
                                          onChange={() => {formik.setFieldValue("premierEnergyTitular", false);}}
                                          type="radio"
                                          id="premierEnergyTitular_nu"
                                          className="hidden"
                                          name="furnizor"
                                       />
                                       <label className="label-radio radius-left-0" htmlFor="premierEnergyTitular_nu">
                                          NU
                                       </label>
                                    </div>
                                    {formik.errors.premierEnergyTitular && formik.touched.premierEnergyTitular ? (
                                       <div className="text-center error-msg">{formik.errors.premierEnergyTitular}</div>
                                    ) : null}
                                 </div>
                              </div>
                                    {formik.values.premierEnergyTitular === false && (
                                    <div id="listaFurnizori">
                                       <div style={{paddingTop: "30px"}} className="col-md-12">
                                          <CustomSelect
                                              options={furnizoriActuali}
                                              value={formik.values.furnizorActual}
                                              onChange={value => {
                                                 formik.setFieldValue("furnizorActual", value.value);
                                              }}
                                              textInfoTitle={true}
                                              hoverText={"Selectează denumirea furnizorului actual de gaze naturale astfel încât acesta să fie notificat cu privire la schimbarea de furnizor efectuată, conform reglementărilor legale în vigoare."}
                                              placeholder="Alege furnizorul..."
                                              id={"furnizorActual"}
                                              name={"furnizorActual"}
                                              labelDescription={"Furnizorul actual"}
                                              isError={formik.errors.furnizorActual && formik.touched.furnizorActual}
                                          />
                                          {formik.errors.furnizorActual && formik.touched.furnizorActual ? (
                                              <div
                                                  className="text-center error-msg">{formik.errors.furnizorActual}</div>
                                          ) : null}
                                       </div>
                                    </div>
                                    )}
                                 </>
                           )}

                           {formik.values.beneficieziInPrezent === false && ( // NU -> se continua pe fluxul PIF, afisand intrebarea "Locul tau de consum este bransat la reteaua de gaze naturale?"
                               <>
                                  <div className="col-md-12 mt-50">
                                     <TextInfo
                                         containerClassNames={"col-md-12 d-flex items-center"}
                                         textClassNames={"mb-0"}
                                         text={"Locul tau de consum este bransat la reteaua de gaze naturale? "}
                                         hoverText={
                                            "Pentru a putea beneficia de gaze naturale la locul tău de consum, trebuie să fii conectat la rețeaua de gaze naturale.  Conexiunea se numește branșament si se realizează între conducta de gaze naturale existentă pe strada ta și firida (aflată la limita proprietății tale) denumită stație/post de reglare și măsurare a debitului."
                                          }
                                       />
                                 <div className="row row-radio">
                                    <div className="col-6 pe-0">
                                       <input
                                          defaultChecked={formik.values.esteBransat}
                                          onChange={() => {
                                             formik.setFieldValue("esteBransat", true);
                                             formik.setFieldValue("isPIF", true);
                                          }}
                                          type="radio"
                                          id="esteBransat"
                                          className="hidden"
                                          name="esteBransat"
                                       />
                                       <label className="label-radio radius-right-0" htmlFor="esteBransat">
                                          DA
                                       </label>
                                    </div>
                                    <div className="col-6 ps-0">
                                       <input
                                          defaultChecked={formik.values.esteBransat === false ? !formik.values.esteBransat : null}
                                          onChange={() => formik.setFieldValue("esteBransat", false)}
                                          type="radio"
                                          id="esteBransat_nu"
                                          className="hidden"
                                          name="esteBransat"
                                       />
                                       <label className="label-radio radius-left-0" htmlFor="esteBransat_nu">
                                          NU
                                       </label>
                                    </div>
                                    {formik.errors.esteBransat && formik.touched.esteBransat ? (
                                       <div className="text-center error-msg">{formik.errors.esteBransat}</div>
                                    ) : null}
                                 </div>
                              </div>

                                 {formik.values.esteBransat === true ? (
                                    <div className="row text-center pt-5">
                                               <AttachFileStep4
                                                  title={"Factura"}
                                                  id={"fileFacturaPIF"}
                                                  setFieldValue={formik.setFieldValue}
                                                  value={formik.values.fileFacturaPIF}
                                                  error={formik.errors.fileFacturaPIF}
                                                  touched={formik.touched.fileFacturaPIF}
                                                  obligatoriu={true}
                                                  textInfoHoverText={"Factura conține taxa pentru punerea în funcțiune a instalației de utilizare. Aceasta este emisă de distribuitor, doar după ce operatorul economic care a efectuat instalația de utilizare, depune documentele pentru punerea în funcțiune a acesteia. Pentru a putea finaliza procesul de contractare aceasta factura trebuie achitata."}
                                                   withTextInfo={true}
                                               />
                                                <AttachFileStep4
                                                   title={"Dovada achitarii serviciului de punere in functiune a instalatiei de utilizare"}
                                                   id={"fileDovadaPlata"}
                                                   setFieldValue={formik.setFieldValue}
                                                   value={formik.values.fileDovadaPlata}
                                                   error={formik.errors.fileDovadaPlata}
                                                   touched={formik.touched.fileDovadaPlata}
                                                   obligatoriu={true}
                                                />
                                    </div> ) : null }

                              </>
                           )}

                           <div id="actionButton">
                              <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} />
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
